module.exports = __webpack_public_path__ + "files/8394ecd9308387362a16004647007577.png";